module.exports = __webpack_public_path__ + "static/media/599.767(23).2b96fe81.pdf";